/* eslint-disable max-classes-per-file */
import { QuestionEvaluationModel } from 'core/models/elements/evaluations/questionEvaluation.abstract.model';

/**
 * @class Defines an evaluation of a sorting question
 */
export class SortingEvaluationModel extends QuestionEvaluationModel {
  /**
   * @constructor Creates an instance of sorting evaluation.
   * @param {sortingQuestion} sortingQuestion is the element to be evaluated.
   */
  constructor(sortingQuestion) {
    super(sortingQuestion);
    this.results = [];
  }
}

/**
 * @class Defines an evaluation result for a sorting question item
 */
export class SortingEvaluationResultModel {
  /**
   * @constructor Creates an instance of sorting evaluation result.
   */
  constructor() {
    this.itemId = null;
    this.isCorrect = false;
    this.isNoAnswer = false;
    this.correctItemId = null;
  }
}
